import axios from 'axios';

const cql2filter = async (string) => {
	let xmlString;
	await axios({
		method: 'GET',
		url:
			process.env.REACT_APP_CONTEXT_PATH +
			'/interactive/api/cql/cql2filter.json',
		params: {
			cqlB64: btoa(string),
		},
	})
		.then((res) => {
			if (res.status === 200) {
				const { data } = res.data;
				xmlString = data;
			}
		})
		.catch((err) => {
			console.log(err);
		});
	return xmlString;
};

export { cql2filter };
